// extracted by mini-css-extract-plugin
module.exports = {"distribution":"styles_distribution__XEbKQ","imageWrapper":"styles_imageWrapper__XKDor","titleAndDescription":"styles_titleAndDescription__GwZw_"};